const { maxWidth } = require('tailwindcss/defaultTheme')

module.exports = {
  ...maxWidth,
  391: '391px',
  704: '704px',
}
